import script from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"

import "./BaseDrawer.vue?vue&type=style&index=0&id=72d1a8f2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d1a8f2"]])

export default __exports__